module.exports = __webpack_public_path__ + "img/6.f485786f.jpg";